"use strict";

import { toBool } from "../../lib/utils.js";
import { Basic } from "../basic.js";
import styles from './frame.css'

/**
 * @class MSFrame
 * @extends Basic
 * @classdesc Контейнер
 * */
export class MSFrame extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat(["datasource", "sizetocontent"]);
    }

    constructor() {
        super();
        const shadowRoot = this.attachShadow({ mode: "open" });
        
        if (this.id == (window.activeMonitorTemplateId ? $WinDefs.constructor.mainFrame[window.activeMonitorTemplateId] : Object.values($WinDefs.constructor.mainFrame)[0])) {
            this._pushState = true;
        }
        this.style.userSelect = "none";
        shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>

            <slot></slot>
            <div class="border border--top"></div>
            <div class="border border--right"></div>
            <div class="border border--bottom"></div>
            <div class="border border--left"></div>
        `;

        this.setInitialBordersValues();

        if (window.ipc) {
            try {
                this.pdfViewer = window.ipc.get().sendSync("server", "getPdf");
            } catch (e) { }
        }
        this._sizetocontent = 1;
        this.firstRun = true;
        this.frameHistory = [];
        //this.historyIdx = 0;

        if ($pm.hasPermissions) {
            this.afterSwitch = this.afterSwitch.bind(this);
            window.addEventListener("ms_message", this.afterSwitch);
        }

        
    }

    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                const curWin = this.firstChild?.id
                this.firstChild.isvisible = curWin !== undefined && $pm.checkOpenWindowRights(curWin) ? true : false;
                break;
        }
    }

    setInitialBordersValues() {
        this.style.borderWidth = 0;
        this.style.setProperty("--borderThickness", "1px");
        this.style.setProperty("--borderStyle", "solid");
        this.style.setProperty("--borderColor", "GRAY");
    }

    set backgroundcolor(value) {
        super.backgroundcolor = value;
        this.updateZ();
    }

    get datasource() {
        return this._datasource;
    }
    set datasource(value) {
        if (this.getStoredWindowState()) {
            return;
        }
        this.setDs(value, false, () => {
            this.updateZ();
        });
    }

    get borderthickness() {
        return this._borderthickness;
    }

    set borderthickness(value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) {
            return;
        }
        this._borderthickness = value;
        this.style.setProperty("--borderThickness", this._setValueUnit(value));
    }

    get bordercolor() {
        return this.style.borderColor;
    }

    set bordercolor(value) {
        this.style.setProperty("--borderColor", this.tryToGetUserColor(value));
    }

    get borderstyle() {
        return this._borderstyle;
    }

    set borderstyle(value) {
        this._borderstyle = value;
        this.style.setProperty(
            "--borderStyle",
            this.getBorderStyle(window._enums.BorderStyleType[value])
        );
    }

    /**
     * Z-порядок
     * @type {number}
     */
    get z() {
        return this._z ?? 0;
    }
    set z(value) {
        this._z = value;
        this.updateZ();
    }

    updateZ() {
        if (!this._msWin && !super.backgroundcolor) {
            super.z = 0;
            return;
        }

        super.z = this.z;
    }

    updateZIndex(value /*:Number*/) {
        if (value > this.contentMaxZIndex) this.contentMaxZIndex = value;
        if (this._maskElement) {
            this._maskElement.style.zIndex = this.contentMaxZIndex + 1;
        }
        this.style.setProperty("--zIndex", this.contentMaxZIndex);
    }

    setDs(value, historyAction, callback) {
        if (this.firstChild && this.firstChild.id == value) {
            if (!this._msWin) this._msWin = this.firstChild;
            this._calcSize();
            callback?.();
            return;
        }
        if (value) {
            //если это не переход по истории (а открытие адреса командой)
            if (!historyAction) {
                if (this.historyIdx == undefined) {
                    this.historyIdx = 0;
                } else {
                    this.historyIdx++;
                    this.frameHistory = this.frameHistory.slice(
                        0,
                        this.historyIdx
                    );
                }
                this.frameHistory.push({ Addr: value });
            }

            this._clearWin();
            this._datasource = value;
            if (value.substr(0, 4) == "http" || this._hasPdfExtension(value) || this._hasHtmlExtension(value)) {
                const credentialedUrlRegex = /^https?:\/\/[^@]+:?[^@]*@/;
                if (credentialedUrlRegex.test(value)) {
                    this.loadIframeWithAuth(value, credentialedUrlRegex, callback);
                    return;
                }
                this.innerHTML = this.createIframe(value);
            } else {
                const winObj = this.createWinObj(value);
                if (winObj) { // todo: а разве возможно такое, что его не будет? тогда что будет вставляться в `this._msWin = this.firstChild` ?
                    this.openWindow(winObj, false, false, true)
                    if ($pm.hasPermissions && !$pm.checkOpenWindowRights(winObj.id)) {
                        this._msWin.isvisible = false
                    }
                    this._calcSize();
                }
            }
            this._msWin = this.firstChild;
            callback?.();
        }
    }

    loadIframeWithAuth(url, credentialedUrlRegex, callback) {
        const [_, username, password] = url.match(/\/\/([^:@]+):?([^@]*)@/);
        const authHeader = 'Basic ' + btoa(`${username}:${password}`);
        const protocol = url.match(/^https?:\/\//)[0];
        const cleanUrl = url.replace(credentialedUrlRegex, protocol);
        fetch(cleanUrl, {
            method: 'GET',
            headers: {
                'Authorization': authHeader
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Не удалось загрузить HTML по адресу ${newUrl}`);
                }
                return response.text();
            })
            .then(html => {
                this.innerHTML = html;
                this._msWin = this.firstChild;
                callback?.();
            })
            .catch(error => {
                console.error(error.message);
            })
    }

    createIframe(value) {
        if (this._hasPdfExtension(value) && this.pdfViewer) {
            const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;
            const clientPrinter = window.clientPrinter && /Linux/.test(platform);
            if (window.ipc && clientPrinter && !window.hasMessageListener) {
                // datasource может прийти новый, либо на странице может быть несколько контролов frame, отображающих pdf-файл.
                // Поскольку в каждом iframe будет вызываться datasource,
                // то нужна проверка, чтобы слушатель события "message" для глобального объекта "window" добавился бы только 1 раз.
                // В противном случае, если на странице есть, например, 3 содержащих pdf-файла iframe,
                // то при вызове печати в одном из них, печать будет вызываться трижды.
                window.hasMessageListener = true;
                window.addEventListener("message", (event) => {
                    const { type } = event.data
                    if (type === 'print') {
                        // при обновлении frame ссылка на файл тоже может меняться,
                        // а поскольку событие прослушки "message" вешается только 1 раз,
                        // путь до файла нужно вычислять при каждом вызове события печати
                        window.ipc.get().send("server", "print", {
                            fileUrl: `${window.location.origin}/${decodeURIComponent(this._datasource)}`
                        });
                    }
                });
            }

            const fileUrl = `${window.location.origin}/${decodeURIComponent(this._datasource)}`;
            const url = `file://${this.pdfViewer}?file=${fileUrl}&clientPrinter=${+!!clientPrinter}`;
            return `<iframe src="${url}" style="width:100%;height:100%;"></iframe>`;
        }
        return `<iframe src="${this._datasource}" style="width:100%;height:100%;"></iframe>`;
    }

    createWinObj(value) {
        if (!value.toString().includes(".")) {
            return $WinDefs.winDef[value];
        }
        const winId = $pr.getWindowIdByPath(value);
        let winObj = winId ? $WinDefs.winDef[winId] : null;
        if (winObj && winObj.objectid === "0") {
            const { objectid, outerpath } = $pr.getObjectIdByPath(value);
            winObj.objectid = objectid;
            winObj.outerpath = outerpath;
        }
        return winObj;
    }

    get sizetocontent() {
        return this._sizetocontent;
    }
    set sizetocontent(value) {
        this._sizetocontent = window._enums.SizeToContentType[value];
        this._calcSize();
    }

    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        const isShow =
            (this.opacity === "" || this._toBool(this.opacity)) &&
            this._toBool(value);
        this.style.display = isShow ? "" : "none";
    }

    _calcSize() {
        if (!this._msWin) {
            return;
        }
        switch (this._sizetocontent) {
            case window._enums.SizeToContentType.RealSize:
                this._msWin.style.transform = ``;
                this._msWin.style.transformOrigin = "";
                this._backWidth = this._width;
                this._backHeight = this._height;
                this._width = this._msWin.width;
                this._height = this._msWin.height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                this.style.overflow = "hidden";
                break;
            default:
            case window._enums.SizeToContentType.SetSize:
                this.style.overflow = "hidden";
                this._width = this._backWidth ? this._backWidth : this._width;
                this._height = this._backHeight
                    ? this._backHeight
                    : this._height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                this._calcScale();
                break;
            case window._enums.SizeToContentType.Crop:
                this._msWin.style.transform = ``;
                this._msWin.style.transformOrigin = "";
                this.style.overflow = "hidden";
                this._width = this._backWidth ? this._backWidth : this._width;
                this._height = this._backHeight
                    ? this._backHeight
                    : this._height;
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                break;
            case window._enums.SizeToContentType.Scroll:
                this._msWin.style.transform = ``;
                this._msWin.style.transformOrigin = "";
                this._width = this._backWidth ? this._backWidth : this._width;
                this._height = this._backHeight
                    ? this._backHeight
                    : this._height;
                this.style.overflow = "auto";
                this.style.width = this._setValueUnit(this._width);
                this.style.height = this._setValueUnit(this._height);
                break;
        }
    }

    _calcScale() {
        const scY = +this._msWin.height;
        const scaleY = +this._height / scY;
        const scX = +this._msWin.width;
        const scaleX = +this._width / scX;

        const winStyle = this._msWin.style;
        const hasRoot =
            this.parentElement && this.parentElement.hasAttribute("root");
        if (hasRoot && this._msWin.proportiontype === 0) {
            winStyle.transform = `scale(${scaleX},${scaleY})`;
            winStyle.transformOrigin = "0 0";
            return;
        }

        const scale = scaleX > scaleY ? scaleY : scaleX;
        if (scale !== 1) {
            winStyle.transform = `scale(${scale})`;
            winStyle.transformOrigin = "0 0";
        } else {
            winStyle.transform = "";
            winStyle.transformOrigin = "";
        }
    }

    openWindow(obj, force, historyAction, disableSaveState) {
        if (!disableSaveState && toBool(this.getAttribute("saveWindowState"))) {
            this.saveItemState({
                windowState: {
                    windowId: obj.id,
                    objectid: obj.objectid,
                    taskid: obj.taskid,
                    outerpath: obj.outerpath,
                },
            });
        }

        const isWindowEqual = (this._msWin && this._msWin.id === obj.id)
            && (obj.objectid == this._msWin.getAttribute("objectid"))
            && (obj.outerpath == this._msWin.getAttribute("outerpath"));
        if (isWindowEqual) {
            return this._msWin;
        }
        if (!force && this._pushState) {
            history.pushState({ obj }, obj.id, window.location.search);
        }

        //если это не переход по истории (а открытие окна командой)
        if (!historyAction) {
            if (this.historyIdx == undefined) {
                this.historyIdx = 0;
            } else {
                this.historyIdx++;
                this.frameHistory = this.frameHistory.slice(0, this.historyIdx);
            }

            this.frameHistory.push({ Obj: obj });
        }

        this._clearWin();
        let param = "";
        const keys = Object.keys(obj);
        keys.forEach(key => {
            if (key !== "windowTriggers") {
                let paramVal = obj[key];
                if (typeof paramVal === "object")
                    paramVal = JSON.stringify(paramVal);
                param += ` ${key}='${paramVal}'`;
            }
        });

        const win = `<ms-window${param}></ms-window>`;

        this.innerHTML = win;

        this._msWin = this.querySelector("ms-window");
        if (obj["windowTriggers"] && !this._msWin.windowTriggers) {
            //TODO
            this._msWin.windowTriggers = JSON.parse(
                JSON.stringify(obj.windowTriggers)
            );
        }
        this._msWin.closeWin = this._clearWin.bind(this);
        this._calcSize();
        if (!this.firstRun) {
            this.afterInitialize();
        }
        this.updateZ(); // окно может быть добавлено только через некоторое время, после того, как появится iframe,
        // и к этому моменту z-index будет равен 0. Поэтому нужно обновлять z-index
        return this._msWin;
    }

    _hasPdfExtension(url) {
        return url.match(/\.pdf$/i);
    }

    _hasHtmlExtension(url) {
        return url.match(/\.html$/i);
    }

    _clearWin() {
        const hasRoot =
            this.parentElement && this.parentElement.hasAttribute("root");
        if (!hasRoot) {
            while (this.firstChild) {
                //this.removeChild(this.firstChild);
                this.firstChild.remove();
            }
            if (this._msWin) {
                this._msWin.remove();
                this._msWin = null;
            }
        }
    }

    afterInitialize() {
        if (this.firstRun) {
            const { windowId, objectid, taskid, outerpath } =
                this.getStoredWindowState() || {};
            if (windowId) {
                const windDef = $WinDefs.winDef[windowId];
                this.openWindow({
                    ...windDef,
                    ...(objectid ? { objectid } : {}),
                    ...(taskid ? { taskid } : {}),
                    ...(outerpath ? { outerpath } : {}),
                });
                this.updateZ();
            }
        }

        for (let i = 0; i < this.children.length; i++) {
            if (this.children[i].afterInitialize)
                this.children[i].afterInitialize();
        }
        this.firstRun = false;
    }

    getStoredWindowState() {
        if (toBool(this.getAttribute("saveWindowState"))) {
            return $ss.getItemState(this.getOriginPath())?.windowState;
        }
    }

    NextPage() {
        if (this.historyIdx != this.frameHistory.length - 1) {
            this.historyIdx++;
            const val = this.frameHistory[this.historyIdx];
            if (val.Addr) {
                this.setDs(val.Addr, true);
            } else {
                this.openWindow(val.Obj, true, true);
            }
        }
    }

    PreviousPage() {
        if (this.historyIdx != 0) {
            this.historyIdx--;
            const val = this.frameHistory[this.historyIdx];
            if (val.Addr) {
                this.setDs(val.Addr, true);
            } else {
                this.openWindow(val.Obj, true, true);
            }
        }
    }

    disconnectedCallback() {
        window.removeEventListener("ms_message", this.afterSwitch);
        super.disconnectedCallback();
    }
}